import { ModalFooter as _ModalFooter, ModalFooterProps as _ModalFooterProps } from "reactstrap";

    export const ModalFooter = _ModalFooter;
    export type ModalFooterProps = _ModalFooterProps;
    